import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { editBlogCategory, getSingleBlogCategory } from "store/actions";
import { useNavigate, useParams } from "react-router-dom";
// import server from "api/server";
// import imageUpload from "assets/svgs/imageUpload.svg";
import { FormattedMessage } from "react-intl";

const EditBlogCategory = () => {
  // const [selectedImage, setSelectedImage] = useState({
  //   preview: null,
  //   path: null,
  // });

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { register, handleSubmit, reset } = useForm();

  const { singleBlogCategory } =
    useSelector((state) => state?.blogCategories) || {};

  useEffect(() => {
    dispatch(getSingleBlogCategory(id));
  }, [dispatch, id]);

  useEffect(() => {
    reset(singleBlogCategory);
  }, [reset, singleBlogCategory]);

  const onSubmit = (data) => {
    // if (selectedImage && selectedImage.path) data["image"] = selectedImage.path;
    // data.image = "uploads/" + data.image.split("/").pop();

    dispatch(editBlogCategory({ id, data, navigate }));
  };

  // const imageChange = async (e) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     const formData = new FormData();
  //     formData.append("file", e.target.files[0]);
  //     const { data } = await server().post("/upload", formData);
  //     setSelectedImage({
  //       preview: e.target.files[0],
  //       path: data.data.files[0].path,
  //     });
  //   }
  // };

  // const removeSelectedImage = () => {
  //   setSelectedImage();
  // };

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>تعديل بيانات التصنيف</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>اسم التصنيف بالعربية</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="اسم التصنيف بالعربية"
                          {...register("title[ar]", { required: true })}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>اسم التصنيف بالانجليزية</h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="اسم التصنيف بالانجليزية"
                          {...register("title[en]", { required: true })}
                        />
                      </div>
                    </div>
                  </Col>
                  {/* <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>وصف التصنيف بالعربية</h5>
                      <div>
                        <textarea
                          type="text"
                          className="form-control form-outline"
                          placeholder="وصف التصنيف بالعربية"
                          {...register("description[ar]", { required: true })}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>وصف التصنيف بالانجليزية</h5>
                      <div>
                        <textarea
                          type="text"
                          className="form-control form-outline"
                          placeholder="وصف التصنيف بالانجليزية"
                          {...register("description[en]", { required: true })}
                        />
                      </div>
                    </div>
                  </Col> */}

                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        <FormattedMessage id="save" />
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditBlogCategory;
